import React, { Component } from 'react';
import axios from "axios";
import env from "../../env";
import "./Current.css"

class Current extends Component {
    state = {
        tasks: [],
        loop: parseInt(env.tasks.refreshInterval),
        timerTitles: this.props.timerTitles
    }

    interval = parseInt(env.tasks.refreshInterval);

    componentDidMount() {
        this.getData();
        if (process.env.NODE_ENV !== 'development') {
            setInterval(this.loop, 1000);
        }
    }

    loop = async () => {
        this.interval -= 1;
        if (this.interval <= 0) {
            this.interval = parseInt(env.tasks.refreshInterval);
            this.getData();
        }
        this.setState({loop: this.interval});
    }

    getData = async () => {
        let tasks = [];
        let user = {};

        const getStartOfMonthTimestamp = () => {
            const now = new Date();
            const startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
            return startOfMonth.getTime();
        };

        const getEndOfMonthTimestamp = () => {
            const now = new Date();
            const endOfMonth = new Date(now.getFullYear(), now.getMonth() + 1, 0, 23, 59, 59, 999);
            return endOfMonth.getTime();
        };

        const varGetStartOfMonthTimestamp = getStartOfMonthTimestamp();
        const varGetEndOfMonthTimestamp = getEndOfMonthTimestamp();

        for(let i = 0; i < this.props.devTeam.length; i++) {
            user = {};
            const response = await axios.get(env.ClickUp.api+'team/'+env.ClickUp.team_id+'/time_entries/current?assignee='+this.props.devTeam[i].id, {
                headers: {
                    'Authorization': env.ClickUp.access_token,
                    'Content-Type': 'application/json'
                }
            });

            const response_time = await axios.get(env.ClickUp.api+'team/'+env.ClickUp.team_id+'/time_entries?assignee='+this.props.devTeam[i].id+'&start_date='+varGetStartOfMonthTimestamp+'&end_date='+varGetEndOfMonthTimestamp, {
                headers: {
                    'Authorization': env.ClickUp.access_token,
                    'Content-Type': 'application/json'
                }
            });
            let duration = 0;
            if (response_time.data.data !== null) {
                for(let j = 0; j < response_time.data.data.length; j++) {
                    duration += parseInt(response_time.data.data[j].duration);
                }
            }

            user.name = this.props.devTeam[i].name;
            user.duration = (duration/1000/60/60).toFixed(1);

            if (response.data.data !== null) {
                user.timer_id = response.data.data.id;
                user.task_name = response.data.data.task.name;
                user.started = response.data.data.start;

            }

            tasks.push(user);
        }

        this.setState({tasks: tasks});
    }

    /* componentDidUpdate - be carefull it runs on every secound due to interval */
    componentDidUpdate(prevProps, prevState, snapshot) {
        /*if (JSON.stringify(prevState.timerTitles) !== JSON.stringify(this.props.timerTitles)) {
            this.setState({timerTitles: this.props.timerTitles});
        }*/
    }

    render() {

        const tbody = this.state.tasks.map((task, index) => {
            let timer_title = 'N/A';
            if (task.timer_id !== undefined) {
                timer_title = task.task_name;
            }

            return (
               <tr key={"user_id_" + index} className={task.timer_id === undefined ? "backgroundRed" : "backgroundGreen"}>
                   <td>{task.name}</td>
                   <td>{timer_title}</td>
                   {
                       task.started !== undefined ?
                           <td>{new Intl.DateTimeFormat('sl-SI', {year: 'numeric', month: '2-digit',day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit'}).format(task.started)}</td> : <td>N/A</td>
                   }
                   <td>{task.duration}</td>
               </tr>
           )
        });

        return (
            <div className="col-6">
                <div className="card">
                    <div className="card-body">
                        <div className="table-responsive">
                            <table className="table text-left">
                                <thead>
                                <tr>
                                    <th scope="col">Uporabnik</th>
                                    <th scope="col">Task</th>
                                    <th scope="col cntdown_holder">Začetek</th>
                                    <th scope="col cntdown_holder">Ta mesec opravljenih ur<span className="cntdown">{this.state.loop}</span></th>
                                </tr>
                                </thead>
                                <tbody>
                                {tbody}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Current;